import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.UPLOAD_MEDIA_SUCCESS:
      return Object.assign({}, state, {
        media: {
          url: action.media.url || '',
          ui: action.ui,
          name: action.name,
        },
      });
    case constants.UPLOAD_MEDIA_ERROR:
      return Object.assign({}, state, { error: action.error });
    default:
      return state;
  }
}
